import { ACTIONS } from 'tracker.constants';

const initialState = {
  addressData: false,
  newDestinationInfo: null,
  newComplement: null
};

export default function packageAddress(state = initialState, action) {
  const nextState = { ...state };
  if (action.type === ACTIONS.SAVE_NEW_DESTINATION_INFO) {
    nextState.addressData = action.addressData;
    nextState.newDestinationInfo = action.newDestinationInfo;
    nextState.newComplement = action.newComplement;
  }
  return nextState;
}
